import { forwardRef } from 'react';
import { IconProps } from '../iconTypes';
const SVGIcon = forwardRef<SVGSVGElement, IconProps>(({
  size = 14,
  ...props
}, svgRef) => {
  if (size) {
    props.width = size;
    props.height = size;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" viewBox="0 0 512 512" ref={svgRef} {...props}><path d="M217.8 15c3.7-9 12.5-15 22.2-15h32c9.8 0 18.6 5.9 22.2 15l182.7 449H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h11.1L217.8 15zM386 368H126l-39.1 96h338.2l-39-96zm-19.5-48l-45.6-112H191.1l-45.6 112h221zM210.6 160h90.8L256 48.4 210.6 160z" /></svg>;
});
SVGIcon.displayName = "RegularTrafficCone";
export default SVGIcon;